<template>
  <div>
    <breadcrumb-component
        :mainTitle="'Billing'"
        :moduleTitle="'Vlan Cloud'"
        :subTitle="'Billing'"
    />
    <div class="row">
      <div class="col-md-12">
        <div class="card card_full_window vc_account_page ">
          <div class="card-body">
            <div class="common_content_wrap no_left_content">
              <h5 class="common_subtitle pb_15 border-lightgray-bottom mb_0">Billing Area</h5>
              <div v-if="hasPermission" class="common_tab_list">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <template v-for="tab in tabs" :key="`tab_${tab.slug}`">
                    <li
                        v-if="!tab.permission || can(tab.permission)"
                        role="presentation"
                        class="nav-item"
                        :class="{active: selectedTab === tab.slug}"
                        @click="selectTab(tab.slug)"
                    >
                      <button
                          class="nav-link"
                          :class="{active: selectedTab === tab.slug}"
                          id="Account-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#Account-tab-pane"
                          type="button"
                          role="tab"
                          aria-controls="Account-tab-pane"
                          :aria-selected="{active: selectedTab === tab.slug}"
                      >
                        {{ tab.name }}
                      </button>
                    </li>
                  </template>
                </ul>
              </div>
              <div v-else>
                <p>You do not have permission to view this content.</p>
              </div>
              <div v-if="hasPermission" class="common_tab_content">
                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade show active" id="Account-tab-pane" role="tabpanel" aria-labelledby="Account-tab" tabindex="0">
                    <div class="my_account_content">
                      <component
                          :is="selectedComponent"
                          :selectedTab="selectedTab"
                      >
                      </component>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {shallowRef} from "vue";
import {useAbility} from "@casl/vue";
import BreadcrumbComponent from "@/components/shared/BreadcrumbComponent.vue";
import Payments from "@/views/billing/Payments.vue";
import Invoices from "@/views/billing/Invoices.vue";

export default{
  name: "BillingIndex",
  components: {BreadcrumbComponent},
  props: ['slug'],
  data() {
    return {
      tabs: [
        { id: 1, name: 'Payments', slug: 'payments', component: shallowRef(Payments), permission: 'payment_list' },
        { id: 2, name: 'Invoices', slug: 'invoices', component: shallowRef(Invoices), permission: 'invoice_list' },
      ],
      selectedTab: 'payments',
    }
  },
  computed: {
    selectedComponent() {
      return this.tabs.find(el => el.slug === this.selectedTab).component;
    },
    hasPermission() {
      return this.tabs.some(tab => !tab.permission || this.can(tab.permission));
    }
  },
  watch: {
    $route() {
      // Watch the route change to update the selected tab
      this.selectedTab = this.getTabFromRoute();
    }
  },
  created() {
    this.selectedTab = this.getTabFromRoute();
  },
  methods: {
    selectTab(selectedTab) {
      this.selectedTab = selectedTab;
      this.$router.push({ name: 'billing', params: { slug: selectedTab } });
    },
    getTabFromRoute() {
      const tabSlug = this.slug;
      return this.tabs.some(tab => tab.slug === tabSlug) ? tabSlug : this.selectedTab;
    },
  },
  setup() {
    const { can } = useAbility();

    return {
      can
    };
  },
}
</script>
<style scoped>

</style>